export enum DataHooks {
  LOGIN_SECTION = 'login-section',
  LOGIN_TEXT = 'login-text',
  LOGIN_BUTTON = 'login-button',
}
